import ReactMarkdown, { Options } from 'react-markdown';
import { cn, memoClassNames } from '@/utils';
import { components } from './components';

const classes = memoClassNames('Markdown', ['root']);

export type MarkdownProps = React.ComponentProps<'div'> & {
  overrides?: Options['components'];
  content?: string;
  remarkPlugins?: Options['remarkPlugins'];
};

export function Markdown({
  content,
  overrides,
  className,
  ...others
}: MarkdownProps) {
  const mdComponents = { ...components, ...overrides };
  return (
    <ReactMarkdown
      {...others}
      className={cn(classes.root, 'mm:relative', className)}
      components={mdComponents}
    >
      {content}
    </ReactMarkdown>
  );
}
